export const API_URL = "https://plesh-remote-multi-user-api-y2qbyk5t3a-ew.a.run.app/"
//export const API_URL = "http://localhost:8080/"
//export const TOOLPRESS_API = "https://api-tool-press-yn26wrnl4q-ey.a.run.app"
export const TOOLPRESS_API = "https://toolpress-api.2ndstage.app"

export const THEME_CONFIG = {
    mode:"dark",
    gradients: {
      default: ['#B7DAF4', '#B7DAF4'],
      home_question: ['#B7DAF4', '#B7DAF4'],
      applausometro: ['#fbb03b', '#fbb03b'],
      siNo:['#fbb03b', '#fbb03b'],
      sentiment: ['#fbb03b', '#fbb03b'],
    },
    borders : {
        default: 'none',
        home_question: 'none'
    },
    borderRadius: {
        default: '1rem',
        photo: '0rem',
        textField: '0rem !important'
    },

    primary: '#fbb03b',
    secondary: '#263238',
    accent: '#fbb03b',
    text: '#fff',
    background:"#4ab2e1",
    poll:{
        default:"#B7DAF4",
        answered:"#FBB03B",
        correct: '#3A722D',
        wrong: '#DB0A16'
    },
    pollBorder: {
        default:"#B7DAF4",
        answered:"#FBB03B",
        correct: '#00D916',
        wrong: '#FB3B3B'
    },
    pollTextColor: {
        default:"#293557",
        answered:"#293557",
        correct: '#293557',
        wrong: '#293557'
    }
}